<style scoped>
    .shift-controls__container {
        position: absolute;
        right: 15px;
        top: 10px;
    }

    .shift-controls__container button[disabled] {
        background: grey !important;
        border-color: grey;
    }
</style>
<template>
    <div class="shift-controls__container">
        <b>{{ shift }}:</b>
        <button
            class="btn btn-sm btn-success"
            :disabled="setButtonAbility('start')"
            v-on:click="sendShiftControl('start')"
        >
            <i class="fa fa-clock-o" aria-hidden="true"></i>
            {{ button_start }}
        </button>
        <button
            class="btn btn-sm btn-info"
            :disabled="setButtonAbility('pause')"
            v-on:click="sendShiftControl('pause')"
        >
            <i class="fa fa-pause" aria-hidden="true"></i>
            {{ button_pause }}
        </button>
        <button
            class="btn btn-sm btn-success"
            :disabled="setButtonAbility('resume')"
            v-on:click="sendShiftControl('resume')"
        >
            <i class="fa fa-play" aria-hidden="true"></i>
            {{ button_resume }}
        </button>
        <button
            class="btn btn-sm btn-danger"
            :disabled="setButtonAbility('stop')"
            v-on:click="sendShiftControl('stop')"
        >
            <i class="fa fa-stop" aria-hidden="true"></i>
            {{ button_stop }}
        </button>
    </div>
</template>
<script>
    export default {
        props: ['button_start', 'button_stop', 'button_pause', 'button_resume', 'shift'],
        data: function () {
            return {
                shift_state: null,
            };
        },
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
            this.getCurrentShiftState();
        },
        methods: {
            sendShiftControl(type) {
                if (type === "stop" && !confirm('Вы уверены что хотите закончить смену?')) {
                    return false;
                }

                this.$http
                    .post('/shop/shifts/control', {type: type})
                    .then(this.getCurrentShiftState).catch(function (response) {
                    alert(response.data.message);
                });
            },
            getCurrentShiftState() {
                this.$http
                    .get('/shop/shifts/current_state')
                    .then((response) => this.shift_state = response.data.shiftState);
            },
            setButtonAbility(buttonType) {
                if(this.shift_state) {
                    let availableStates = {
                        'none': ['start'],
                        'start': ['pause', 'stop'],
                        'stop': ['start'],
                        'resume': ['pause', 'stop'],
                        'pause': ['resume']
                    };

                 return !availableStates[this.shift_state].includes(buttonType);
                }
            }
        }
    }
</script>
